import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { PermissionScopeResponse } from "~types/permissionScope";

const useGetCurrentUserPermissionScopeToManagePermissions = () => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  return useQuery({
    queryKey: ["permission-scope-to-manage-permissions-current-user", sport, organizationId],
    queryFn: () =>
      request<PermissionScopeResponse>(`${sport}/o/${organizationId}/user/permissions/scope`).then((response: PermissionScopeResponse) => ({
        scope: response.data?.[0],
        resources: response.includes?.resources,
      })),
    staleTime: () => 5 * 60 * 1000,
  });
};

export default useGetCurrentUserPermissionScopeToManagePermissions;
